<template>
  <div style="height: 56px; max-width: 56px;" class="pt-1">
    <!-- Visiteur facebook -->
    <wz-avatar
      v-if="avatars[0].network == 'facebook'"
      :username="avatars[0].username"
      :src="avatars[0].src"
      size="32px"
      class="pl-1"
      :isTyping="avatars[0].isTyping"
      :lastMessage="avatars[0].lastMessage"
      :chip="avatars[0].chip"
    ></wz-avatar>
    <!-- Visiteur whatsapp -->
    <wz-avatar
      v-else-if="avatars[0].network == 'whatsapp'"
      :username="avatars[0].username"
      :src="avatars[0].src"
      size="32px"
      class="pl-1"
      :isTyping="avatars[0].isTyping"
      :lastMessage="avatars[0].lastMessage"
      :chip="avatars[0].chip"
    ></wz-avatar>
    <!-- Visiteur moon -->
    <wz-avatar
      v-else
      :username="'#' + avatars[0].id"
      :src="null"
      size="32px"
      class="pl-1"
      :isTyping="avatars[0].isTyping"
      :lastMessage="avatars[0].lastMessage"
      :chip="avatars[0].chip"
    ></wz-avatar>
    <!-- Agent -->
    <wz-avatar
      :username="avatars[1].username"
      :src="`${domaine}/public/media/user/small/${avatars[1].id}_avatar.jpg`"
      size="30px"
      class="avatar-bottom"
    ></wz-avatar>
  </div>
</template>

<style lang="css" scoped>
.avatar-bottom {
  right: 0;
  bottom: 0;
  left: 12px;
  top: -12px;
  position: relative;
}
</style>

<script>
import { DOMAINE } from '../../constants'
export default {
  data () {
    return {
      domaine: DOMAINE
    }
  },
  name: 'WzAvatarDouble',
  props: {
    avatars: {
      type: Array,
      required: true,
      default: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAvatarDouble.vue